import React from 'react'
import { components } from 'react-select'

import { Box, Text, Tooltip } from '@chakra-ui/react'
const CustomOption = ({ children, ...props }) => {
  // eslint-disable-next-line no-unused-vars
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps
  const newProps = { ...props, innerProps: rest }

  return (
    <Box _hover={{ bg: '#deebff', transitionDelay: '60ms' }} transition={'background 60ms'}>
      <components.Option {...newProps}>
        <Tooltip label={children} zIndex={'10000'} placement="auto-start">
          <Text textOverflow={'ellipsis'} maxH="40px" noOfLines={1}>
            {children}
          </Text>
        </Tooltip>
      </components.Option>
    </Box>
  )
}

export default CustomOption
